import React from "react";
import LoadingButton from '@mui/lab/LoadingButton';
import { ISaveButton } from "./ButtonInterfaces";

export default function ButtonSaveCustom({
  //Propiedade que vai dentro do botão, aceita qualquer item, inclusive Icones
  children,
  onClick,
  typeButton,
  fullWidth = false,
  //Quando true retorna um icone de crregamento e desativa o click do botão.
  loading = false
}: ISaveButton) {
  const buttonStyle = {
    backgroundColor: "#1976d2 !important",
    color: "white",
    margin:1,
  };

  return (
    <LoadingButton
      variant={typeButton}
      onClick={onClick}
      fullWidth={fullWidth}
      sx={buttonStyle}
      loading={loading}
    >
      {children} 
    </LoadingButton>
  );
}
